import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericElement } from '../models/interface';
import { catchError, map, tap } from 'rxjs/operators';
// import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  // private apiUrl = 'http://localhost:3001/api'; // Replace with your Node.js server API URL
  private _apiUrl = 'http://localhost:8080/api/ent?ent';
  private size: number = 5;

  private readonly _http = inject(HttpClient);

  getTableByName(tableName: string, page: number = 0): Observable<any> {
    const url = `${this._apiUrl}/${tableName}&page=${page}&size=${this.size}`;
    return this._http.get<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  //obetener registros hijo
  getTableRegisterAllById(tableName: string, tableId: string, id: string, page: number = 0): Observable<any> {
    // return this._http.get<any>(`${this._apiUrl}=${tableName}&${tableId}=${id}&page=${page}&size=${this.size}`)
    const url = `${this._apiUrl}/${tableName}&${tableId}=${id}&page=${page}&size=${this.size}`;
    return this._http.get<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  getTableRegisterById(tableName: string, id: string): Observable<any> {
    // return this._http.get<any>(`${this._apiUrl}=${tableName}&id=${id}`)
    const url = `${this._apiUrl}/${tableName}&id=${id}`;
    return this._http.get<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  getDenominacion(denominacion: any): Observable<any> {
    // return this._http.get<any>(`${this._apiUrl}/denominacion/${denominacion}`)
    const url = `${this._apiUrl}/denominacion/${denominacion}`;
    return this._http.get<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  postCreate(tableName: string, data: GenericElement): Observable<any> {
    // return this._http.post(`${this._apiUrl}=${tableName}`, { ...data, })
    const url = `${this._apiUrl}/${tableName}`;
    return this._http.post<any>(url, { ...data }).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  putUpdateRegisterById(tableName: string, id: string, data: GenericElement): Observable<any> {
    // return this._http.put<any>(`${this._apiUrl}=${tableName}&id=${id}`, { ...data })
    const url = `${this._apiUrl}/${tableName}&id=${id}`;
    return this._http.put<any>(url, { ...data }).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  filterTableByColumn(tableName: string, valueToFilter: string, tableId?: string, id?: any, page: number = 0): Observable<any> {
    const idcontent = id ? `${tableId}=${id}` : '';
    // return this._http.get<any>(`${this._apiUrl}=${tableName}&${idcontent}&${valueToFilter}&page=${page}&size=${this.size}&sort=nombre,asc`)
    const url = `${this._apiUrl}/${tableName}&${idcontent}&${valueToFilter}&page=${page}&size=${this.size}&sort=nombre,asc`;
    return this._http.get<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  postBuscar(tableName: string, value: string, tableId?: string, id?: any, page: number = 0): Observable<any> {
    const idcontent = id ? `${tableId}=${id}` : '';
    // return this._http.get(`${this._apiUrl}=${tableName}&${idcontent}&any=${value}&page=${page}&size=${this.size}&sort=nombre,asc`)
    const url = `${this._apiUrl}/${tableName}&${idcontent}&any=${value}&page=${page}&size=${this.size}&sort=nombre,asc`;
    return this._http.get<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  deleteRegister(tableName: string, value: string): Observable<any> {
    // return this._http.delete(`${this._apiUrl}=${tableName}&ids=${value}`)
    const url = `${this._apiUrl}/${tableName}&ids=${value}`;
    return this._http.delete<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  uploadFile(file: File, idOrigen: string, origen: string): Observable<number> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('idOrigen', idOrigen);
    formData.append('origen', origen);

    const request = new HttpRequest('POST', 'http://localhost:8080/api/documentos', formData, {
      reportProgress: true,
    });

    return this._http.request(request).pipe(
      map((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          const percentDone = event.total ? Math.round((100 * event.loaded) / event.total) : 0;
          return percentDone;
        } else if (event instanceof HttpResponse) {
          return 100;
        }
        return 0; // Devolver un valor predeterminado si el evento no es HttpEventType.UploadProgress ni HttpResponse
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  getFile(origen: string, id: string, page: number = 0) {
    // return this._http.get(`http://localhost:8080/api/documentos?origen=${origen}&idOrigen=${id}&page=${page}&size=${this.size}`)
    const url = `${this._apiUrl}/documentos?origen=${origen}&idOrigen=${id}&page=${page}&size=${this.size}`;
    return this._http.get<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  deleteFile(tableName: string, id: string) {
    // return this._http.delete(`http://localhost:8080/api/${tableName}/${id}`)
    const url = `${this._apiUrl}/${tableName}/${id}`;
    return this._http.delete<any>(url).pipe(
      // map((resp: any) => [resp]),
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  downloadFile(id: string) {
    return this._http.get(`http://localhost:8080/api/documentos/${id}`, { responseType: 'blob' });
    // const url = `${this._apiUrl}/documentos/${id}`;
    // return this._http.get<any>(url, { responseType: 'blob' })
    // .pipe(
    //   // map((resp: any) => [resp]),
    //   tap((resp: any) => { return resp }),
    //   catchError((err: any) => {
    //     throw err;
    //   })
    // );
  }
}
